import ReactGA from 'react-ga4';

export const initGA = () => {
    ReactGA.initialize('G-ESEMHCY9FK');
}

export const GApageView = () => {
  ReactGA.send('pageview');
}
